import React, { useState } from 'react';
import { ProductPageCard } from './ProductPageCard';
import image1 from '../../assets/productpage/walkthrough-premium1.png';
import image2 from '../../assets/productpage/walkthrough-premium2.png';
import { CallToActionBanner } from '../CallToActionBanner';
import suggestions from '../../Data/Suggestion';
import { useLocation, useParams } from 'react-router-dom';

export const ProductPageNew = () => {
  const [activeTab, setActiveTab] = useState(1);
  const location = useLocation();
  const data = location.state;

  const tabs = [
    { id: 1, tab: 'All' },
    { id: 2, tab: 'Walkthrough' },
    { id: 3, tab: 'Onboarding' },
    { id: 4, tab: 'Profile' },
    { id: 5, tab: 'Calendar' },
    { id: 6, tab: 'Navigation' },
    { id: 7, tab: 'ProPhoto & Mediafile' },
    { id: 8, tab: 'eCommerce' },
    { id: 9, tab: 'Navigation' },
    { id: 10, tab: 'Social Media' },
  ];

  return (
    <div className='max-w-7xl mx-auto px-4'>
      <ProductPageCard data={data} />
      <h3 className='text-center text-2xl'>User Flows (All-Screens Preview)</h3>
      <ul className='overflow-x-scroll hidescroll border dark:border-[#5B5B5B] my-6 rounded-lg px-5 py-3 flex justify-between items-center space-x-4'>
        {tabs.map(tab => (
          <li
            key={tab.id}
            className={`shrink-0 rounded-lg px-4 py-2 cursor-pointer ${
              activeTab === tab.id ? 'bg-[#1C1C1C]  text-white dark:bg-white dark:text-[#1c1c1c]' : ' text-black dark:text-white'
            }`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.tab}
          </li>
        ))}
      </ul>
      <div>
        <h1 className='text-xl md:text-2xl py-4 text-center'>1. Walkthrough</h1>
        <img className='w-fit mx-auto' src={image1} alt='' />
      </div>
      <div className='mb-10'>
        <h1 className='text-xl md:text-2xl py-4 text-center'>2. Onboarding</h1>
        <img className='w-fit mx-auto' src={image2} alt='' />
      </div>
      <CallToActionBanner
        att={'bg-[#1C1C1C] text-white dark:bg-white dark:text-black'}
        buttonColor={'bg-white text-black dark:!bg-black dark:!text-white'}
      />

      <div className='pb-10'>
        <h1 className='text-2xl py-2'>You might also like</h1>
        <div className='flex flex-col py-2 space-y-6 md:space-y-0 md:flex-row md:space-x-6'>
          {suggestions.map(suggest => (
            <div key={suggest.title}>
              <img className='object-cover h-60 w-full rounded-xl' src={suggest.imgUrl} alt='' />
              <div className='py-2 flex items-center justify-between space-x-4'>
                <h3 className='text-xl'>{suggest.title}</h3>
                <p className='bg-[#1C1C1C] dark:bg-white dark:text-black px-3 py-1 rounded-lg text-white w-fit'>
                  ${suggest.price}
                </p>
              </div>
              <div className='flex space-x-4 items-center'>
                <img className='w-8 h-8 rounded-full' src={suggest.author} alt='' />
                <p>{suggest.name}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
